import React, { Component } from "react";
import CloseCross from "../../../../assets/images/closeCross.svg";
import RowBg from "./RowBg";
import "../Column.scss";
import Tabs from "./Tabs";
import Popup from "../../../Modal/Popup";
class RowSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
    };
  }
  setIdForEditHandler = (editID) => {
    this.setState({});
  };
  componentDidMount = () => { };

  render() {
    return (
      <Popup
        width="700"
        header="Row Settings"
        parentID="rowSettingWrapper"
        closePopup={() => this.props.setIdForEditHandler(null)}
        close={() => this.props.setIdForEditHandler(null)}
      >
        <div className="mainSection">
          <RowBg
            rowCroppedBg={this.props.rowCroppedBg}
            rowBg={this.props.rowBg}
            rowBgColor={this.props.rowBgColor}
            rowOpacity={this.props.rowOpacity}
            rowBorderColor={this.props.rowBorderColor}
            borderWidth={this.props.borderWidth}
            ID={this.props.ID}
            name={this.props.name}
            label={this.props.label}
            initP={this.props.initP}
            bgRepeat={this.props.bgRepeat}
            bgSize={this.props.bgSize}
            userID={this.props.userID}
            sessionID={this.props.sessionID}
            gutterSpaceBtwnCol={this.props.gutterSpaceBtwnCol}
            gutterSpaceBtwnColMobile={this.props.gutterSpaceBtwnColMobile}
            rowStyle={this.props.rowStyle}
            closeModal={() => this.props.setIdForEditHandler(null)}
          />
        </div>
        <div className="clearfix"></div>
      </Popup>
    );
  }
}
export default RowSetting;
